export const FounderFrame = ({ eyebrow, testid, children, wide = false }) => (
  <div className="bg-ivory min-h-screen" data-testid={testid}>
    <section className="pt-40 lg:pt-52 pb-24">
      <div className={`mx-auto px-6 sm:px-10 ${wide ? 'max-w-6xl' : 'max-w-3xl'}`}>
        {eyebrow && <div className="eyebrow !text-gold mb-8">{eyebrow}</div>}
        {children}
      </div>
    </section>
  </div>
);
